// 画面フェーズ
export const PHASE = {
  START: 'start', // SSM4起動確認
  DEVICE_DISCONNECT_ERROR: 'deviceDisconnectError', // デバイス切断失敗
  START_SSM4_ERROR: 'startSSM4Error', // SSM4起動失敗
};